<template>
    <div>
        <div v-if="options && options.length > 0">
            <!-- Loop through options and create checkboxes -->
            <div v-for="(option, index) in options" :key="index">
                <v-checkbox :label="option.name"
                            v-model="checkedOptions[index]"
                            :disabled="disabled" />
            </div>
            
        </div>
        <div v-else>
            <p>No options available</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                required: true
            },
            value: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            validate: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                checkedOptions: [] // Array to store the checked state of each option
            }
        },
        watch: {
            value: {
                handler() {
                    this.syncCheckedOptions()
                },
                immediate: true,
                deep: true
            },
            checkedOptions: {
                handler() {
                    this.updateSelectedValue()
                    this.emitValidationState() // Emit validation state whenever checkedOptions change
                },
                deep: true
            }
        },
        computed: {
            isValid() {
                // Validation logic: Check if at least one checkbox is checked
                return this.checkedOptions.some(checked => checked)
            }
        },
        methods: {
            syncCheckedOptions() {
                this.checkedOptions = this.options.map(option => this.value && this.value.includes(option.id))
            },
            updateSelectedValue() {
                const newSelectedValue = this.options
                    .filter((option, index) => this.checkedOptions[index])
                    .map(option => option.id)

                if (JSON.stringify(newSelectedValue) !== JSON.stringify(this.value)) {
                    this.$emit('input', newSelectedValue)
                }
            },
            emitValidationState() {
                // Emit the validation state to the parent
                this.$emit('validation-state', this.isValid || !this.validate)
            }
        },
        mounted() {
            // Initialize checkedOptions array
            this.syncCheckedOptions()
            this.emitValidationState() // Emit initial validation state
        }
    }
</script>

<style scoped>
    .error-message {
        color: red;
        font-size: 0.9em;
    }
</style>

<style>
    /* Bold checkbox labels for answer options */
    .v-checkbox >>> label,
    .v-input--checkbox >>> .v-label {
        font-weight: 700 !important;
    }
</style>